module.exports = "/_next/static/images/listing@2x-20af7a7c4c3c61f94203dce5cf907427.png";